import { defineComponent as _defineComponent } from 'vue'
import TradeReportListing from 'ah-trades/src/components/lists/TradeReportListing.vue';
import { tradeAndComissionReportTableFields } from 'ah-trades/src/models/tradeTableFields';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import TradeReportListFilters from 'ah-trades/src/components/lists/TradeReportListFilters.vue';
import ListDownloadButton from 'ah-common-lib/src/common/components/listing/ListDownloadButton.vue';
import { ExportListType, PaginatedParams, PartnerReport } from 'ah-api-gateways';
import SortSelector from 'ah-common-lib/src/common/components/SortSelector.vue';
import { CommissionDisplayType, PaginatedResponse } from '../../../../ah-api-gateways/models';
import { cloneDeep } from 'lodash';
import { computed, ref, reactive, watch } from 'vue';
import { useTradeState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchableTradeReportList',
  props: {
    showSearch: { type: [Boolean, String], default: true },
    showDates: { type: [Boolean, String], default: false },
    withRowDetails: { type: [Boolean, String], default: false },
    commonFilters: { default: () => ({}) },
    openTrade: null,
    showExport: { type: [Boolean, String], default: false }
  },
  setup(__props: any) {

const props = __props as { showSearch: boolean | string, showDates: boolean | string, withRowDetails: boolean | string, commonFilters: any, openTrade?: string, showExport: boolean | string };

const tradeReportListing = ref<InstanceType<typeof TradeReportListing> | null>(null);



const state = reactive({
  // Automatically syncronised via .sync
  dataDownloadState: 'idle',
  sortAndPageParams: {
    sort: 'createdAt',
    sortDirection: 'DESC',
    pageSize: 10,
  } as Partial<PaginatedParams>,
  allFilters: {} as any,
  filter: { pageSize: 10 } as any,
  commissionDisplayType: CommissionDisplayType.ORIGINAL as CommissionDisplayType,
  homeCurrency: null as string | null,
});

const tradeState = useTradeState();

const isStackedView = computed(() => {
  return tradeState.mediaQuery.is('smDown');
});

const isApportioned = computed(() => {
  return state.commissionDisplayType === CommissionDisplayType.APPORTIONED;
});

const cleanedFilters = computed(() => {
  const { pageSize, ...out } = state.filter;
  return out;
});

function onFilterUpdate(filter: any) {
  state.filter = { ...filter, pageSize: state.sortAndPageParams?.pageSize };
}

const tableFields = computed(() => {
  const out = cloneDeep(tradeAndComissionReportTableFields(state.homeCurrency ?? undefined));
  const keys = ['gbpPartnerCommissions', 'partnerInitialMarginCreditChargeAmount', 'gbpPartnerNetCommission'];
  out.forEach((field: any) => {
    if (keys.includes(field.key)) {
      field.sortKey = isApportioned.value
        ? 'remaining' + field.key[0].toUpperCase() + field.key.substring(1)
        : field.key;
    }
  });
  return out;
});

function onDataUpdate(data: Partial<PaginatedResponse<PartnerReport>>) {
  state.homeCurrency = data?.list?.find((i) => i.homeCurrency)?.homeCurrency ?? null;
}

function onSortAndPageParamsChange() {
  state.filter.pageSize = state.sortAndPageParams?.pageSize;
}

watch(
  () => state.sortAndPageParams,
  () => {
    onSortAndPageParamsChange();
  }
);

watch(
  () => props.openTrade,
  () => {
    if (props.openTrade) {
      state.filter.referenceNumber = props.openTrade;
    }
  },
  { immediate: true }
);

function downloadList(format: ExportListType) {
  tradeReportListing.value!.downloadData(format);
}

state.filter = { ...props.commonFilters, ...state.allFilters };

const debouncedFilterChange = debounce(() => {
  const filter = { ...props.commonFilters, ...state.allFilters };
  if (!isEqual(filter, state.filter)) {
    state.filter = filter;
  }
}, 1500);

function setFilters(filtersAndDisplay: any) {
  const { commissionDisplayType, pageSize, ...filters } = filtersAndDisplay;
  state.allFilters = filters;
  state.sortAndPageParams.pageSize = pageSize;
  state.commissionDisplayType = commissionDisplayType;
}

function onFiltersChange() {
  debouncedFilterChange();
}

watch(
  () => state.allFilters,
  () => {
    onFiltersChange();
  }
);

return { __sfc: true,tradeReportListing, props, state, tradeState, isStackedView, isApportioned, cleanedFilters, onFilterUpdate, tableFields, onDataUpdate, onSortAndPageParamsChange, downloadList, debouncedFilterChange, setFilters, onFiltersChange, TradeReportListing, TradeReportListFilters, ListDownloadButton, SortSelector }
}

})